import { Directive, OnInit, ViewContainerRef } from '@angular/core';
import { PageLoadingService } from './page-loading.service';

/**
 * This directive should be added to your app.component in order to use the page.loading.decorator
 */
// TODO this directive shouldn't be necessary once angular allows to create the component without elementRef:
// https://github.com/angular/angular/issues/45263
// https://github.com/angular/angular/pull/46685
@Directive({
  selector: '[rxApplicationsPageLoading]',
})
export class PageLoadingDirective implements OnInit {
  constructor(private viewContainerRef: ViewContainerRef, private showLoadingService: PageLoadingService) {}

  ngOnInit(): void {
    this.showLoadingService.viewContainerRef = this.viewContainerRef;
  }
}
